import { useEffect, useRef, useState } from "react";
import LayeredDashboardHeader from "../LayeredDashboardHeader";
import useCustomNavigate from "../../components/operational/goBack";
import PrimaryButton from "../../components/ui/PrimaryButton";
import CreateAction from "../../components/operational/createAction";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { CheckboxGroup, Checkbox } from "@nextui-org/react";
import UploadImgPublish from "../../components/ui/UploadImgPublish";
import { useSelector } from "react-redux";
import { uploadBlobImage } from "../../helper/Helpers";
import { useDispatch } from "react-redux";
import myAppsSlice from "../../redux/myAppsSlice";


const StoreSettings = ({ tab }) => {
    const back = useCustomNavigate(tab)
    const dispatch = useDispatch()
    const [allowedAdminLogin, setAllowedAdminLogin] = useState(false)
    const timezones = [
        { name: '(GMT+03:00) İstanbul/Avrupa', code: '3' },
    ]
    const [selectedTimezone, setSelectedTimezone] = useState(timezones[0]);
    const currencies = [
        { name: 'Türk Lirası', code: 'TL' },
    ]
    const [selectedCurrency, setSelectedCurrency] = useState(currencies[0]);
    const localReduxData = useSelector((state) => state.myAppsSlice?.localReduxData);
    const app = localReduxData?.app
    const [appLogo, setAppLogo] = useState(app.appLogo)
    const updateStoreSettings = async () => {

        try {
            const logo = await uploadBlobImage(appLogo)
            if (!logo) throw new Error("Image could not be loaded!")
            const response = await CreateAction({
                method: 'post',
                path: '/storeSettings',
                data: { currency: selectedCurrency.code, timezone: selectedTimezone.code, allowedAdminLogin, appLogo: logo },
                showPreLoader: true,
                isFileUploading: false,
            });
            if (response?.error) return

            back()
            const newData = { ...localReduxData, app: { ...app, appLogo: logo } }
            dispatch(myAppsSlice.actions.setLocalReduxData(newData))
        } catch (error) {
            console.log(error)

        }
    }

    useEffect(() => {
        const getStoreSettings = async () => {

            try {
                const response = await CreateAction({
                    method: 'get',
                    path: '/storeSettings',
                    data: {},
                    showPreLoader: true,
                    isFileUploading: false,
                });
                if (response?.error) return
                const { allowedAdminLogin, timezone, currency } = response?.result?.resultData
                setAllowedAdminLogin(allowedAdminLogin)
                setSelectedCurrency(currencies?.find(c => c.code == currency))
                setSelectedTimezone(timezones?.find(t => t.code == timezone))


            } catch (error) {

            }
        }
        getStoreSettings()
    }, [])

    return (
        <>
            <LayeredDashboardHeader tab={tab}></LayeredDashboardHeader>
            <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
                <div>
                    <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1120px] mx-auto gap-[20px]">
                        <div className="bg-white p-[20px] rounded-[10px] 2xl:p-[40px] max-w-[1120px] w-[100%] flex flex-col gap-[30px]">
                            <div className="flex flex-row justify-between w-full items-center relative ">
                                <div className="text-[#5E5873] text-[18px] font-semibold">Mağaza Ayarları</div>
                            </div>
                            <div className="flex flex-row gap-[20px] relative">
                                <div className="flex flex-col gap-[10px] flex-1">
                                    <span className="text-[#8A92A6] mb-[5px] block font-medium text-[14px] ">
                                        Para Birimi</span>
                                    <Dropdown value={selectedCurrency} onChange={(e) => setSelectedCurrency(e.value)}
                                        options={currencies} optionLabel="name"
                                        className="w-full h-[45px]" />
                                </div>
                                <div className="flex flex-col gap-[10px] flex-1">
                                    <span className="text-[#8A92A6] mb-[5px] block font-medium text-[14px] ">
                                        Saat Dilimi </span>
                                    <Dropdown value={selectedTimezone} onChange={(e) => setSelectedTimezone(e.value)}
                                        options={timezones} optionLabel="name"
                                        className="w-full h-[45px]" />
                                </div>
                            </div>
                            <div className="flex flex-col gap-[10px]">
                                <div>Mağaza Resmi</div>

                                <UploadImgPublish
                                    accept={{
                                        'image/png': ['.png'],
                                    }}
                                    required
                                    output={{ width: 192, height: 192 }}
                                    preImage={appLogo}
                                    boxHeight={192}
                                    boxWidth={192}
                                    onChange={e => {
                                        setAppLogo(e);
                                    }}
                                    label=""
                                    placeholder=""
                                    text={''}
                                    obJectFit={'cover'}
                                    error={'error'}
                                    uploadType={2}
                                    resolution={'192x192'}
                                    imageText={'*Görsel tam istenilen boyutta olmalıdır'}
                                />
                            </div>
                            <div className="flex flex-row justify-between w-full  ">
                                <div className='flex flex-col gap-[20px]'>
                                    <div className='flex flex-col gap-[20px]'>
                                        <span className='text-[#5E5873] text-[18px] font-semibold'>Hesaba Erişim Yetkisi</span>
                                        <Checkbox isSelected={allowedAdminLogin} value={allowedAdminLogin} onChange={(e) => setAllowedAdminLogin(state => !state)} color='secondary' >Mobligo Destek Ekibinin hesabıma erişebilmesine izin veriyorum.</Checkbox>
                                    </div>
                                </div>
                                <PrimaryButton onClick={updateStoreSettings} value={"Kaydet"} classes="h-[50px] my-auto" />
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        </>


    );
};

export default StoreSettings;
